import { HTMLAttributeAnchorTarget, useContext, type JSX } from 'react';

import { Icon, LinkAsButton, Typography } from '@/shared/ui';

import { trackSliderClick } from '@/loader/trackSliderClick';

import { ServicesContext } from '@/contexts/Services/ServicesContext';

import { AdaptiveImage } from '../AdaptiveImage/AdaptiveImage';

import type { ColorConfig } from '@/contexts/AntdConfigProvider/theme';
import type { ExternalImgPath, ImgPath } from '@/shared/ui';

type Props = {
  header: string;
  text?: string | null;
  img: {
    desktop: ExternalImgPath | ImgPath;
    mobile: ExternalImgPath | ImgPath;
  };
  resolvedLink?: string;
  target?: HTMLAttributeAnchorTarget;
  text_color?: ColorConfig | null;
  serviceCode?: string | null;
};

export const HeroInfoSliderSlide: React.FC<Props> = ({
  header,
  img,
  text,
  resolvedLink,
  target = '_self',
  text_color,
  serviceCode,
}): JSX.Element => {
  const { services } = useContext(ServicesContext);

  const showButton =
    !!resolvedLink && (!serviceCode || services?.some((s) => s.code === serviceCode && s.isAvailable === true));

  return (
    <div className="hero-info-slider__item">
      <div className="container">
        <div className="hero-info-slider__item-content">
          <Typography color={text_color ?? 'black'} as="h3" variant="H1" className="hero-info-slider__item-title">
            {header}
          </Typography>
          {text && (
            <Typography color={text_color ?? 'black'} as="h4" className="hero-info-slider__item-text">
              {text}
            </Typography>
          )}
          {showButton && resolvedLink && (
            <LinkAsButton
              className="hero-info-slider__item-link"
              to={resolvedLink}
              target={target}
              rel="noopener noreferrer nofollow"
              onClick={(): void => trackSliderClick(resolvedLink, header)}
            >
              <Icon name="arrow_forward" /> Детальніше
            </LinkAsButton>
          )}
        </div>
      </div>

      <div className="hero-info-slider__item-image">
        <AdaptiveImage
          className="hero-info-slider__item-image-tag"
          desktopSrc={img.desktop}
          mobileSrc={img.mobile}
          alt={header}
        />
      </div>
    </div>
  );
};
